import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';




function AllLandingSlides(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [allLandingSlides, setAllLandingSlides] = useState([]);

    axios.defaults.withCredentials = true;



    

    const getAllLandingSlides = ()=>{
        axios.post('AllItems', {
            table: 'landing_text',
        })
        .then((res) => {
            if (res.data) {
                setAllLandingSlides(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    





    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }





    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'landing_text',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
                getAllLandingSlides();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };




useEffect(() => {

    getAllLandingSlides();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <table>

                    <thead>
                        <tr>
                            <th> # </th>
                            <th> Sub Header </th>
                            <th> Header </th>
                        </tr>
                    </thead>
                    <tbody>
                    {allLandingSlides.length ? (
                    allLandingSlides.map((landingslide) => {
                        return (
                        <tr key={landingslide.id}>
                            
                            <td>
                            <h6>{landingslide.id}</h6>
                            </td>


                            <td>
                                <h6>{landingslide.sec_header}</h6>
                            </td>
                            
                            <td>
                            <h6>{landingslide.header}</h6>
                            </td>

                            <td><Link className='edit' to={`/edit-landing-slide?id=${landingslide.id}`}> <i class="las la-edit"></i> </Link></td>


                        </tr>
                        );
                    })
                    ) : (
                    <tr>
                        <td colSpan={5}>Loading...</td>
                    </tr>
                    )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllLandingSlides;